import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a695e4c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box-box"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "tools-grid"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "tool-icon"
};
import { ref, computed } from 'vue';
import { Link, Monitor, Grid, Timer, Guide, Box, Location } from '@element-plus/icons-vue';
export default {
  __name: 'codeNav',
  setup(__props) {
    const navigateTo = url => {
      window.location.href = url;
    };

    // 定义工具列表
    const tools = [{
      title: "时间转换工具",
      description: "时间转换工具可以帮助您在不同时间格式之间进行快速转换",
      url: "/timechange.html",
      icon: Timer
    }, {
      title: "URL编码、解码",
      description: "提取网页url，进行编码或解码，轻松获取url参数",
      url: "/urlencode.html",
      icon: Link
    }, {
      title: "JSON格式化",
      description: "轻松把JSON格式化，美观阅读,解析字段",
      url: "/jsoncode.html",
      icon: Guide
    }, {
      title: "JSON/XML 互转",
      description: "轻松把JSON转成Xml，Xml 转JSON",
      url: "/jsonxml.html",
      icon: Monitor
    }, {
      title: "JSON转译",
      description: "轻松把stringJSON转成对象，把对象转成stringJSON",
      url: "/jsonstring.html",
      icon: Grid
    }, {
      title: "SQL/JSON 互转",
      description: "轻松把SQL转成JSON，把JSON转成SQL",
      url: "/sqljson.html",
      icon: Grid
    }, {
      title: "EXCEL/JSON 互转",
      description: "轻松把EXCEL转成JSON，把JSON转成EXCEL",
      url: "/jsonexcel.html",
      icon: Grid
    }, {
      title: "CSV/JSON 互转",
      description: "轻松把CSV转成JSON，把JSON转成CSV",
      url: "/jsoncsv.html",
      icon: Grid
    }, {
      title: "YAML/JSON 互转",
      description: "轻松把YAML转成JSON，把JSON转成YAML",
      url: "/jsonyaml.html",
      icon: Grid
    }, {
      title: "JWT 加密/解密",
      description: "轻松加密JWT / 解密JWT",
      url: "/jwt.html",
      icon: Grid
    }, {
      title: "Base64 加密/解密",
      description: "轻松加密Base64 / 解密Base64",
      url: "/base64password.html",
      icon: Grid
    }, {
      title: "3D模型预览工具",
      description: "支持多种常见的 3D 模型文件格式，如 GLTF、GLB、OBJ、FBX 等，能让用户方便地加载不同来源的模型",
      url: "https://www.douchuanwei.com/api/ar/three/editor/index.html",
      icon: Box
    }, {
      title: "MarkDown文本转微信公众号格式工具",
      description: "支持多种常见的 3D 模型文件格式，如 GLTF、GLB、OBJ、FBX 等，能让用户方便地加载不同来源的模型",
      url: "https://www.douchuanwei.com/api/ar/wxformat/index.html",
      icon: Box
    }, {
      title: "网站地图",
      description: "查询当前网站地图链接",
      url: "/map.html",
      icon: Location
    }];

    // 定义搜索查询和过滤后的工具列表
    const searchQuery = ref('');
    const filteredTools = computed(() => {
      if (searchQuery.value === '') {
        return tools;
      }
      return tools.filter(tool => {
        const titleMatch = tool.title.toLowerCase().includes(searchQuery.value.toLowerCase());
        const descriptionMatch = tool.description.toLowerCase().includes(searchQuery.value.toLowerCase());
        return titleMatch || descriptionMatch;
      });
    });
    return (_ctx, _cache) => {
      const _component_ChromeFilled = _resolveComponent("ChromeFilled");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_ChromeFilled)]),
        _: 1
      }), _createTextVNode(" 编程工具 ")]), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchQuery.value = $event),
        type: "text",
        placeholder: "搜索",
        class: "search-input"
      }, null, 512), [[_vModelText, searchQuery.value]])]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTools.value, (tool, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "tool-card",
          onClick: $event => navigateTo(tool.url)
        }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_icon, {
          is: tool.icon
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(tool.icon)))]),
          _: 2
        }, 1032, ["is"])]), _createElementVNode("h3", null, _toDisplayString(tool.title), 1), _createElementVNode("p", null, _toDisplayString(tool.description), 1)], 8, _hoisted_5);
      }), 128))])]);
    };
  }
};